var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoEnclosedFilled = function SvgInfoEnclosedFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01151 0.115982C3.61151 0.115982 0.0115051 3.71598 0.0115051 8.11598C0.0115051 12.516 3.61151 16.116 8.01151 16.116C12.4115 16.116 16.0115 12.516 16.0115 8.11598C16.0115 3.71598 12.4115 0.115982 8.01151 0.115982ZM9.01151 12.116H7.01151V7.11598H9.01151V12.116ZM8.01151 6.11598C7.41151 6.11598 7.01151 5.71598 7.01151 5.11598C7.01151 4.51598 7.41151 4.11598 8.01151 4.11598C8.61151 4.11598 9.01151 4.51598 9.01151 5.11598C9.01151 5.71598 8.61151 6.11598 8.01151 6.11598Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoEnclosedFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-enclosed-filled.f6ce1db4.svg";
export { ForwardRef as ReactComponent };